import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: ['AkkuratLL', 'sans-serif'].join(','),
  },
  palette: {
    primary: {
      main: '#2F4A73',
    },
    secondary: {
      main: '#FC6558',
    },
  },
});

export default theme;
